module.exports = __webpack_public_path__ + "img/gangpigy.137ebf16.jpg";